// extracted by mini-css-extract-plugin
export var closeButton = "_g1-2";
export var closeButtonIcon = "_g1-3";
export var lightboxContent = "_g1-1";
export var lightboxOverlay = "_g1-0";